export class UncontrolledTransactionValidationErrorResponse {
  identifier: any;
  propertyTransferred: any;
  transferDateYear: any;
  value: any;
  units: any;
  description: any;
  'partyRole.partyRoleId': any;
  'transactionType.transactionTypeId': any;
}
